import React from 'react';
import { ColumnButton } from 'lib/components/ColumnButton';
import { OrganizationModel } from 'lib/model/objects/organizationModel';
import { getNewspaperLogo } from 'routes/ads/place/helpers/newspapers';
import { getPublisherLocationDescription } from './SelectPublisherDropdown';

type SelectedPublisherCardProps = {
  publisherOrganizationModel: OrganizationModel;
  onPublisherOrganizationChange: (publisherOrganizationId: string) => void;
  tags?: React.ReactNode[];
};

export function SelectedPublisherCard({
  publisherOrganizationModel,
  onPublisherOrganizationChange,
  tags
}: SelectedPublisherCardProps) {
  const publisherLogo = getNewspaperLogo(publisherOrganizationModel);

  return (
    <>
      <p className="text-sm text-column-gray-700 font-semibold py-2">
        Selected publisher
      </p>
      <div className="mb-4 border p-3 rounded-md">
        {publisherLogo && (
          <div>
            <img
              className="h-12 max-w-48 object-contain rounded-lg"
              src={publisherLogo}
            />
          </div>
        )}
        <div className="space-y-1">
          <h2 className="text-lg text-column-gray-700 font-semibold">
            {publisherOrganizationModel.modelData.name}
            <span className="text-sm font-normal"> | Public Notices</span>
          </h2>
          <p className="text-sm font-normal">
            {getPublisherLocationDescription(
              publisherOrganizationModel.modelData
            )}
          </p>
          {tags && (
            <div className="flex flex-wrap gap-2 mt-2">
              {tags.map(tag => tag)}
            </div>
          )}
        </div>
      </div>
      <ColumnButton
        type="button"
        buttonText="Search for a different publisher"
        secondary
        onClick={() => onPublisherOrganizationChange('')}
      />
    </>
  );
}
